export enum FeatureFlag {
	// Value kept as 'gustave_enabled' to match the existing PostHog flag key
	PRISM = 'gustave_enabled',
	FEATURE_DISCOVERY = 'featureDiscovery',
	KABEEN_INTELLIGENCE = 'kabeen_intelligence',
	INSTALLED_PROGRAMS_SERVER = 'installed_programs_server',
	INSTALLED_PROGRAMS_WORKSTATION = 'installed_programs_workstation',
	WORKSTATIONS_DASHBOARD = 'workstations_dashboard_enabled',
}
